;(() => {
  document.addEventListener('click', (e) => {
    const button = e.target.closest('button')
    if (button) {
      if (button.matches('.js-menu-toggle')) {
        const header = button.closest('.site-header')
        header.classList.toggle('mobile-nav-active')
        if (header.classList.contains('mobile-nav-active')) {
          document.body.style.overflow = 'hidden'
          const event = new CustomEvent('mobileNavOpened')
          document.dispatchEvent(event)
        } else {
          document.body.style.overflow = 'auto'
          header
            .querySelector('.intl-menu__mobile .intl-menu')
            .classList.remove('active')
        }
      }
      if (button.matches('.nav-menu-item')) {
        const span = button.querySelector('span')
        const div = button.parentElement.querySelector('div')
        span.classList.toggle('rotate-180')
        div.classList.toggle('max-h-0')
      }
    }
  })

  document.addEventListener('cartOpened', () => {
    const header = document.querySelector('.site-header')
    header.classList.remove('mobile-nav-active')
    document.body.style.overflow = 'auto'

    const intlMenu = header.querySelector('.intl-menu__mobile .intl-menu')
    if (intlMenu) {
      intlMenu.classList.remove('active')
    }
  })
})()
